// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"3eaa4c90","413":"5cec62d0"}[chunkId] + ".chunk.js";
};